// extracted by mini-css-extract-plugin
export default {"App":"src_App__jv16Y","ar":"src_ar__fGUHb","en":"src_en__HaqAH","fr":"src_fr__NTg13","goToUp":"src_goToUp__thMqj"};